// extracted by mini-css-extract-plugin
export default {"panel":"HbsipD5MkR7ZWsAF6i92","help":"TlBOwdbc6SD9YAMvEpO1"};